<template>
  <div v-show="!empty">
    <div class="testimonial-holder" v-if="showing" ref="tholder">
      <div class="close-box grey" v-on:click="hideMe" v-show="visible"></div>
      <transition name="fade">
        <testimonial-panel :artist="artist" v-if="artist" v-show="visible" v-on:empty="handleEmpty" />
      </transition>
    </div>
    <div class="testimonial-button" v-if="!showing && (mwidth > 640)">
      <div class="vertical-button" v-on:click="showMe">{{ $nippets.testimonials }}</div>
    </div>
  </div>
</template>

<script>
import TestimonialPanel from '@/components/panels/TestimonialPanel.vue'
import MeasurablePage from '@/mixins/MeasurablePage.js'
// prop artist is the portfolio url
export default {
  mixins: [MeasurablePage],
  components:{
    TestimonialPanel
  },
  props: {
    artist: String
  },
  data () {
    return {
      showing: true,
      visible: true,
      empty: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    handleEmpty (val){
      this.empty = val
    },
    async hideMe () {
      this.visible = false
      await this.$k.waitfor(300)
      this.showing = false
      this.$store.commit('setArtistTestimonialState', { artist: this.artist, value: true})
    },
    async showMe () {
      this.showing = true
      this.visible = true
      this.$store.commit('setArtistTestimonialState', { artist: this.artist, value: false})
      this.$nextTick(() => {
        this.$refs.tholder.scrollIntoView({ behavior: 'smooth', block: 'center'})
      })
    },
    async init () {
      if(this.artist){
        this.showing = !this.$store.getters.getArtistTestimonialState(this.artist)
        this.visible = this.showing
      }
    }
  },
  watch: {
    artist () {
      this.init()
    }
  }
}
</script>

<style>
.testimonial-holder{
  position:absolute;
  top:110vh;
  left:0;
  z-index:45;
  width:100%;
  box-sizing:border-box;
  opacity:0.95;
}

.vertical-button{
  transform: rotate(-90deg);
  color:#fff;
  background-color:#ac9e3c;
  position:fixed;
  right:11px;
  top:calc(95vh - 140px);
  padding:3px 15px 3px 39px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-size:16px;
  z-index:51;
  transform-origin: center right;
  background-image:url('../../assets/img/plus-button.svg');
  background-size:16px 16px;
  background-position:12px 50%;
  cursor:pointer;
}

.vertical-button:hover{
  background-color:#ce0e2d;
}
</style>